<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div class="widget-location">
			<h3>로켓머니 충전/사용 내역</h3>
		</div>
		<div class="list-top">
			<div class="page-info">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>
		
		<el-table
			    :data="tableData"
			    stripe empty-text="데이타가 없습니다."
			    style="width: 100%">
		<!-- 	    <el-table-column
			      type="index"
			      label="순번"
			      width="80">
			    </el-table-column> -->
				<el-table-column
				  label="내역">
					<template slot-scope="scope">	     
						<i class="el-icon-s-promotion"></i> 
						<span style="cursor:pointer;" > {{ scope.row.description }}</span>				           
					</template>
				</el-table-column>
				<el-table-column
				  prop="change_amount"
				  label="사용예치금"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="after_balance"
				  label="누적예치금"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="createtime"
				  label="등록일"
				  width="200">
				</el-table-column>
			</el-table>
			<div class="page">
				<el-pagination
					layout="prev, pager, next" :page-size="20"
					:total="total"  @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return{
				loading: true,
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				this.loading = true

				request.post('/member/Cybercash/balanceLog',
					{
						page:this.page,
						currency: this.$route.query.currency,//URL 上的参数传过去
					}
				).then(res => {
					this.loading = false
					console.log(res,"balanceLog")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}
					
						
				}).catch(() => {
					this.loading = false
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
		}
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	::v-deep .el-table__header th {
		color: #333; 
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		.page{
			padding-bottom: 20px;
		}
	}
</style>